import { useTranslation } from 'react-i18next'

import { SubTitle, Text } from '@/components/common/UI'
import { Icons } from '@/components/icons'
import {
    Button,
    Modal,
    ModalBody,
    ModalContent,
    ModalFooter,
    ModalHeader,
    Link
} from '@/components/nextui'

interface LogoutMessageProps {
    isOpen: boolean
    onClose: () => void
}

export const LogoutMessage = ({
    onClose,
    isOpen
}: LogoutMessageProps): JSX.Element => {
    const { t } = useTranslation()
    const text = 'logoutMessage'

    return (
        <Modal
            backdrop="opaque"
            isOpen={isOpen}
            onClose={onClose}
            isDismissable={false}
            isKeyboardDismissDisabled={true}
            placement="center"
            motionProps={{
                variants: {
                    enter: {
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 0.3,
                            ease: 'easeOut'
                        }
                    },
                    exit: {
                        y: -20,
                        opacity: 0,
                        transition: {
                            duration: 0.2,
                            ease: 'easeIn'
                        }
                    }
                }
            }}
        >
            <ModalContent>
                {(onClose) => (
                    <>
                        <ModalHeader>
                            <SubTitle
                                subTitle={t(`${text}.title`)}
                                className="text-primary"
                            />
                        </ModalHeader>
                        <ModalBody>
                            <div className="flex gap-2">
                                <Icons.Light />
                                <Text text={t(`${text}.email`)} />
                            </div>

                            <div className="flex gap-2 mt-2">
                                <Icons.Light />
                                <Text text={t(`${text}.password`)} />
                            </div>

                            <div className="flex gap-2 mt-2">
                                <Icons.Light />
                                <Link
                                    isExternal
                                    showAnchorIcon
                                    href="https://universidadean.edu.co/meli-turno"
                                >
                                    {t(`${text}.link`)}
                                </Link>
                            </div>
                        </ModalBody>
                        <ModalFooter className="flex justify-center">
                            <Button
                                color="primary"
                                onPress={onClose}
                            >
                                {t('ok')}
                            </Button>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    )
}
